export default __webpack_public_path__ + "static/media/login.c7bc28a8.png";